<template>
<section class="freebook_consultant gray_section">

    <div class="wrap">
        <h2 class="section_title">프리북 추천 전시장</h2>
    </div>

    <swiper v-if="shopItems.length > 0"
        class="swiper freebook_consultant_ul freebook_showroom_ul mh11"
        :options="swiperOption"
    >
        <swiper-slide class="item" 
            v-for="shop in shopItems" 
            :key="`main-shop-item-${shop.id}`"
        >
            <a class="carousel-shadow" @click="$router.push(`/shopInfo/${shop.id}`)">
                <figure>

                    <img :src="viewShopAttUrl(shop.attUrl)">
                    <span v-if="shop.reviewCount > 9">
                        <img :src="$store.state.resource.imgIconGood2">{{getRateGood(shop)}}%
                    </span>
                    <!--
                    <dl>
                        <dt>{{shop.name}} </dt>
                        <dd>{{shop.dealerName}}<span><i class="fas fa-heart"></i>3</span></dd>
                    </dl>
                    -->
                </figure>
              
                <figcaption>
                    <dl>
                        <dt>
                            <p>{{shop.name}} 전시장</p>
                            <span style="color:#003594; text-shadow:none">
                                <i class="fas fa-star"></i> 
                                {{reviewRatingAvg(shop.reviewSum, shop.reviewTotal)}}({{shop.total}}명)
                            </span>
                        </dt>
                        <dd><!-- v-if="shop.reviewCount > 9"-->
                            <span v-for="(rank, idx) in getRankingList(shop)" :key="`shop-${shop.id}-keyword-${idx}`">{{rank.keyword}}</span>
                        </dd>
                    </dl>
                    <p>
                        <span>{{shop.brandName}}</span>
                        <span>{{shop.dealerName}}</span>
                    </p>
                </figcaption>
               
            </a>
        </swiper-slide>
    </swiper>
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';

export default {
    name:'MainShop',
    mixins: [ NumberFormatMixin ],
    components: {
    },
    props: {
        onload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            swiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 1.3, //화면에 slide 노출 개수
            },
            
            shopItemsOnload: [],
            shopItems: [],
        }
    },
    computed: {
        ...mapState({
            // shopItems : state => state.shop.items,
            DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SHOP_DETAIL_SCORE,
            resource: state => state.resource,
            // onload: state => state.common.onload,
        }),
        ...mapGetters([
            'viewShopAttUrl'
        ])
    },
    watch: {
        onload(val) {
            if(val) {
                this.shopItems = this.shopItemsOnload;
            }
        }
    },
    created () {
    },
    methods: {
        
        async getItems() {
            await this.$store.dispatch('GET_SHOP_LIST_PAGE',{
                size:5,
                orderby: "DISTANCE",
                lat : this.$store.state.currentLocationLat,
                har : this.$store.state.currentLocationHar,
            }).then((data)=>{
                this.shopItemsOnload = data.content;
            }).catch((e)=> {
                throw e;
            });
        },

        getRateGood(data) {
            return this.$_getRateGood(data.good, data.normal, data.bad)
        },

        getRankingList(data) {
            let result = this.$_getRankingList([data.detailA
                                                , data.detailB
                                                , data.detailC
                                                , data.detailD
                                                , data.detailE
                                                , data.detailF]);

            result.forEach( (item) => {
                item.keyword = this.DETAIL_SCORE[item.type].content;
            })

            result.length = 2;

            return result;
        }
    }
}
</script>

<style scoped>

</style>